import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable, catchError, filter, map, of, } from 'rxjs';
import { environment as env } from '../environments/environment';
import { IChangePassword, ISignInResponse, IUser, IUserAdmin, IUserLogin, IUserRegister, Suggest } from '../models/interfaces/user.model';
import { NavigationEnd, Router } from '@angular/router';
import { StaffLoginResponse } from '../models/interfaces/staff';
import { CrispChatService } from './crisp-chat.service';
import { BrowserService } from './browser.service';

import { tap, shareReplay, throwError } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class AuthService {
  private validateCache$: Observable<IUser> | null = null;

  apiURL = `${env.apiUrl}auth/`;
  apiURLStaff = `${env.apiUrl}staff/`;
  routeName: BehaviorSubject<string | null> = new BehaviorSubject<string | null>(null)
  userShop: BehaviorSubject<IUser | null> = new BehaviorSubject<IUser | null>(null);
  currentCountry: BehaviorSubject<any> = new BehaviorSubject({});
  logoutAtSessionExpired: BehaviorSubject<boolean> = new BehaviorSubject(false);




  constructor(
    private http: HttpClient,
    private Router: Router,
    private crispChatService: CrispChatService,
    private browserService: BrowserService
  ) {
    this.getRouteName();
  }


  getRouteName() {
    this.Router.events.pipe(filter(event => event instanceof NavigationEnd))
      .subscribe((event: any) => {
        this.routeName.next(event.url)
      });
  }

  updateUserShop(user: IUser | null) {
    this.userShop.next(user);
  }

  getUserShop(): IUser | null {
    let user: IUser | null = null;
    this.userShop.subscribe({
      next: (value) => {
        user = value
      }
    })
    return user
  }

  signInUser(user: IUserLogin): Observable<ISignInResponse> {
    return this.http.post<ISignInResponse>(`${this.apiURL}signin`, user);
  }

  signUp(user: IUserRegister): Observable<IUser> {
    return this.http.post<IUser>(`${this.apiURL}signup`, user);
  }
  linkUserWithFingerprint(fingerprint: any): Observable<IUser> {
    return this.http.post<IUser>(`${this.apiURL}link-fingerprint`, fingerprint);
  }
  // return message string
  logout() {
    const sessionStorageBr = this.browserService.getSessionStorage();
    if (sessionStorageBr) {
      sessionStorage.setItem('userExist', 'false')
    }
    this.crispChatSessionReset()
    return this.http.get(`${this.apiURL}logout`);
  }
  //return message as string
  changePassword(changePassword: IChangePassword): Observable<IUser> {
    return this.http.post<IUser>(`${this.apiURL}change-password`, changePassword)
  }
  forgotPassword(email: IUserAdmin): Observable<any> {
    return this.http.post<any>(`${this.apiURL}forgot-password`, email);
  }
  resetPassword(token: any, newPassword: any): Observable<IUser | any> {
    return this.http.patch<IUser>(
      `${this.apiURL}reset-password/${token}`, newPassword
    );
  }
  verifyEmail(token: any): Observable<any> {
    return this.http.patch<any>(`${this.apiURL}verify-Email/${token}`,{});
  }
  verifyID(images: any): Observable<IUser> {
    return this.http.post<any>(`${this.apiURL}verify-id`, images);
  }

  // return img to scan
  set2FA(queryParam = '') {
    return this.http.patch<any>(
      `${this.apiURL}set-2fa${queryParam}`,
      {}
    );
  }
  // activate for first time
  activate2FA(token: any): Observable<any> {
    return this.http.patch<any>(`${this.apiURL}activate-2fa/${token}`, {}
    );
  }
  // verify after login
  verify2FA(token: any): Observable<any> {
    return this.http.post<any>(`${this.apiURL}verify-2fa`, token)
  }
  // verify after login in Admin
  verify2FAAdmin(token: any): Observable<any> {
    return this.http.patch<any>(`${this.apiURL}admin/validate-2fa`, token)
  }

  // ! Create Password For Email Of Online Auth
  initiatePasswordSetup(email: ({ email: string })): Observable<any> {
    return this.http.post(`${this.apiURL}initiate-password-setup`, email)
  }

  // ! Verify Token Of User Online Email
  verifyToken(token: string): Observable<any> {
    return this.http.get(`${this.apiURL}verify-password-setup?token=${token}`)
  }

  // ! Set Password For online email
  completePassword(body: any): Observable<any> {
    return this.http.post(`${env.apiUrl}auth/complete-password-setup`, body)
  }


  /*====================== Auth Admin and 2fa ===========================*/
  signInAdmin(user: IUserLogin): Observable<ISignInResponse> {
    return this.http.post<ISignInResponse>(`${this.apiURL}admin/login`, user);
  }

  // return img to scan in Admin
  set2FAAdmin(queryParam = '') {
    return this.http.post<any>(
      `${this.apiURLStaff}send-2fa${queryParam}`, {}
    );
  }
  // activate for first time in Admin
  activate2FAAdmin(token: any): Observable<any> {
    return this.http.patch<any>(`${this.apiURLStaff}verify-2fa/${token}`, {}
    );
  }
  // Disable after login in Admin
  Ddisable2FAAdmin(): Observable<any> {
    return this.http.patch<any>(`${this.apiURLStaff}disable-2fa`, {})
  }
  validateAdmin(): Observable<StaffLoginResponse> {
    return this.http.get<StaffLoginResponse>(`${this.apiURLStaff}me`)
  }
  /*============================================================================*/

  validate(): Observable<IUser> {
    if (this.userShop.getValue()) {
      return of(this.userShop.getValue() as IUser);
    }

    if (!this.validateCache$) {
      this.validateCache$ = this.http.get<IUser>(`${this.apiURL}validate`).pipe(
        tap(user => {
          this.userShop.next(user);
          this.validateCache$ = null; // reset بعد ما تخلص
        }),
        shareReplay(1),
        catchError(err => {
          this.validateCache$ = null;
          return throwError(() => err);
        })
      );
    }

    return this.validateCache$;
  }
  validateActvaite(): Observable<boolean> {
    return this.http.get<IUser>(`${this.apiURL}validate`).pipe(
      map(data => true),
      catchError(error => of(false))
    );
  }
  resendEmail(email: string): Observable<any> {
    return this.http.get<any>(
      `${this.apiURL}resend-email-verivication/${email}`
    );
  }

  adminForgotPassword(email: ({ email: string })): Observable<({ message: string })> {
    return this.http.post<({ message: string })>(`${env.apiUrl}auth/admin-forgot-password`, email);
  }

  adminResetPassword(token: any, newPassword: any): Observable<IUser | any> {
    return this.http.patch<IUser>(
      `${this.apiURL}admin-reset-password/${token}`, newPassword
    );
  }




  // ! =============================== Suggest Language and Currency =================================

  updateSuggestLanguageAndCurrency(suggest: {}): Observable<any> {
    return this.http.post<any>(`${this.apiURL}update-preferences`, suggest);
  }

  getSuggestLanguage(): Observable<Suggest> {
    return this.http.get<Suggest>(`${this.apiURL}suggest-language-currency`,)
  }
  // ! =============================== Crisp Chat =================================


  crispChatSessionReset() {
    this.crispChatService.resetSession();

  }
}
